<script>
export default {
  translate25Context: 'vfigma',
  methods: {},
  props: ["enabled", "type", "labels"],
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div class="f-field f-toggle" :class="[type, { enabled }]">
    <div class="f-toggle-label">
      <slot></slot>
    </div>
    <div class="f-toggle-value">
      <FFadeTransition mode="out-in">
        <div v-if="enabled">{{ labels && labels.enabled || $vt('Enabled') }}</div>
        <div v-else>{{ labels && labels.disabled || $vt('Disabled') }}</div>
      </FFadeTransition>
    </div>
    <div class="f-toggle-switcher" @click="$emit('toggle')">
      <div class="button"></div>
    </div>
  </div>
</template>

<style lang="scss">
.f-toggle {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 7px;

  .f-toggle-label {
    display: flex;
    flex: 1 1 auto;
    gap: 7px;
    align-items: center;
    margin-left: 12px;
  }

  .f-toggle-switcher {
    display: flex;
    align-items: center;

    width: 36px;
    height: 20px;
    background: rgba(24, 144, 211, 0.1);
    border-radius: 24px;
    cursor: pointer;
    transition: all ease 0.25s;

    .button {
      width: 16px;
      height: 16px;
      margin-left: 2px;
      background: #ffffff;
      box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.25);
      border-radius: 16px;
      transition: all ease 0.25s;
    }

    &:hover {
      .button {
        opacity: 0.75;
      }
    }

    &:active {
      .button {
        opacity: 0.5;
      }
    }
  }

  &.enabled {
    .f-toggle-switcher {
      background: var(--blue);
      .button {
        margin-left: 18px;
      }
    }
  }

  &.big {
    .f-toggle-switcher {
      width: 56px;
      height: 32px;

      .button {
        width: 24px;
        height: 24px;
      }
    }
  }

  &.big.enabled {
    .f-toggle-switcher {
      .button {
        margin-left: 28px;
      }
    }
  }
}
.dark-mode {
  .f-toggle {
    padding-left: 4px;
    .f-toggle-label {
      color: var(--white-a75);
	  font-size:12px;
	  font-weight:bold;
	  margin-left:4px;
    }

    .f-toggle-value {
      color: var(--white-a50);
	  font-size:14px;
    }

    .f-toggle-switcher {
      background: var(--navigation-a10);

      .button {
        background: var(--white-a50);
        box-shadow: 0px 4px 16px 0px rgba(22, 22, 21, 0.25);
      }
    }

    &.enabled {
      .f-toggle-switcher {
        background: var(--navigation);
      }
    }
  }
}
</style>
